import React from 'react';
import { Avatar, Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';

interface NameAvatarProps {
    whoAddTask: string;
    style?: React.CSSProperties;
    size?: 'large';
}

const FALLBACK_AVATAR_STYLE: React.CSSProperties = {
    backgroundColor: '#f0f0f0',
    color: '#8c8c8c',
};

const NameAvatar: React.FC<NameAvatarProps> = ({ whoAddTask, size, style }) => {
    return (
        <Tooltip title={whoAddTask} placement="top">
            <span className="app-avatar-wrap" style={{ display: 'inline-flex', lineHeight: 0 }}>
                <Avatar
                    size={size}
                    style={{ ...FALLBACK_AVATAR_STYLE, ...style }}
                    icon={<UserOutlined />}
                    aria-label={whoAddTask}
                />
            </span>
        </Tooltip>
    );
};

export default NameAvatar;
